import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;

const EmployeeDualBrandCardConfig = ({ formProps, isEdit, isLoading }) => {
  const { t } = useTranslation();

  const isDisabled = !isEdit || isLoading;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    dualBranchEnableVisa: {
      fieldType: "checkbox",
      fieldName: "dualBranchEnableVisa",
      label: t(`${FORM_LABEL_KEY}.dualBranchEnableVisa`),
      disabled: isDisabled,
    },
    dualBranchEnableMaster: {
      fieldType: "checkbox",
      fieldName: "dualBranchEnableMaster",
      label: t(`${FORM_LABEL_KEY}.dualBranchEnableMaster`),
      disabled: isDisabled,
    },
    dualBranchEnableAmex: {
      fieldType: "checkbox",
      fieldName: "dualBranchEnableAmex",
      label: t(`${FORM_LABEL_KEY}.dualBranchEnableAmex`),
      disabled: isDisabled,
    },
    dualBranchEnableJcb: {
      fieldType: "checkbox",
      fieldName: "dualBranchEnableJcb",
      label: t(`${FORM_LABEL_KEY}.dualBranchEnableJcb`),
      disabled: isDisabled,
    },
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.cardSwitchingLogicForDualBrandCard`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.cardSwitchingLogicForDualBrandCardMsg`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.dualBranchEnableVisa,
              fieldsConfig.dualBranchEnableMaster,
              fieldsConfig.dualBranchEnableAmex,
              fieldsConfig.dualBranchEnableJcb
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
    </FormBuilder.Section>
  );
};

export default React.memo(EmployeeDualBrandCardConfig);
